import React, { Fragment, useRef, useState } from 'react'
import { Asset } from '@opallabs/kuiper'
import { ContentTextInput } from '../../../../../ContentTextInput'
import { FacebookHeader, FacebookFooter } from '../../../SharedDisplays'
import { FacebookReelDisplayProps } from '../../types'
import * as styles from './styles'

export const MobileNewsFeed: React.FC<FacebookReelDisplayProps> = ({
  accountImage,
  accountName,
  assets,
  collabEnabled,
  collabAccount,
  content,
  contentCharacterLimit,
  contentPlaceholderText,
  isPresenting,
  location,
  readOnly,
  scheduledAt,
  timezone,
  truncate,
  onExpandAsset,
  onRemoveAsset,
  onUpdateContentOption,
  updateCoverAsset,
}) => {
  const asset = assets && assets.length ? assets[0] : null
  const containerRef = useRef<HTMLDivElement>(null)
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Fragment>
      <FacebookHeader
        accountImage={accountImage}
        accountName={accountName}
        collabEnabled={collabEnabled}
        collabAccount={collabAccount}
        location={location}
        scheduledAt={scheduledAt}
        timezone={timezone}
      />
      <div css={styles.captionContainer}>
        <ContentTextInput
          characterLimit={contentCharacterLimit}
          highlightSocialTags={true}
          onChange={(value) => onUpdateContentOption('content', value)}
          placeholder={contentPlaceholderText}
          readOnly={readOnly}
          truncate={truncate}
          truncationLimit={150}
          value={content}
        />
      </div>
      <div
        ref={containerRef}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Asset
          assetReference={asset}
          hasAssetOptions={true}
          preview={false}
          isHovered={isHovered}
          overrideStyles={{
            asset: styles.contentAsset(Boolean(asset)),
            assetBase: styles.contentAsset(Boolean(asset)),
          }}
          disableMediaControls={false}
          hasAssetOverlay={!!asset && (!readOnly || isPresenting)}
          updateCoverAsset={(val: string) => updateCoverAsset(val, asset?.id)}
          onEmbiggen={() => onExpandAsset(asset?.id || 0)}
          onRemove={() => onRemoveAsset(asset?.id || 0)}
        />
      </div>
      <FacebookFooter />
    </Fragment>
  )
}
